import Form from 'react-bootstrap/Form';

export const TradovateConnectionForm = ({
    values,
    onChange,
    allowLiveAccounts,
}) => (
    <>
        <Form.Group className="mb-3" controlId="tradovate-username">
            <Form.Label><h5>Username</h5></Form.Label>
            <Form.Control
                value={values.tradovateUsername}
                onChange={onChange}
                type="text"
                placeholder="Tradovate Username"
                name="tradovateUsername"
                required
            />
        </Form.Group>
        <Form.Group className="mb-3" controlId="tradovate-password">
            <Form.Label><h5>Password</h5></Form.Label>
            <Form.Control
                value={values.tradovatePassword}
                onChange={onChange}
                type="password"
                placeholder="Tradovate Password"
                name="tradovatePassword"
                required
            />
        </Form.Group>
        <Form.Group className="mb-3" controlId="tradovate-key">
            <Form.Label><h5>API Key</h5></Form.Label>
            <Form.Control
                value={values.tradovateKey}
                onChange={onChange}
                type="text"
                placeholder="Tradovate API Key"
                name="tradovateKey"
                required
            />
        </Form.Group>
        <Form.Group className="mb-3" controlId="tradovate-device-id">
            <Form.Label><h5>Device ID</h5></Form.Label>
            <Form.Control
                value={values.tradovateDeviceID}
                onChange={onChange}
                type="text"
                placeholder="Tradovate Device ID"
                name="tradovateDeviceID"
                required
            />
        </Form.Group>
        <Form.Group className="mb-3" controlId="tradovate-chl">
            <Form.Label><h5>CHL</h5></Form.Label>
            <Form.Control
                value={values.tradovateCHL}
                onChange={onChange}
                type="text"
                placeholder="Tradovate CHL"
                name="tradovateCHL"
                required
            />
        </Form.Group>
        <Form.Group className="mb-3" controlId="tradovate-app-id">
            <Form.Label><h5>App ID</h5></Form.Label>
            <Form.Control
                value={values.tradovateAppId}
                onChange={onChange}
                type="text"
                placeholder="Tradovate App Id"
                name="tradovateAppId"
                required
            />
        </Form.Group>
        <Form.Group className="mb-3">
            <Form.Label><h5>Account Type</h5></Form.Label>
            <Form.Check
                type="radio"
                label="Demo Account / Third Party Funded"
                name="tradovateAccountType"
                id="thirdPartyFundedAccount"
                checked={values.tradovateAccountType === 'demo'}
                onChange={onChange}
                value="demo"
            />
            {allowLiveAccounts && (
                <Form.Check
                    type="radio"
                    label="Live Account"
                    name="tradovateAccountType"
                    id="personallyFundedAccount"
                    checked={values.tradovateAccountType === 'live'}
                    onChange={onChange}
                    value="live"
                />
            )}
        </Form.Group>
    </>
);
